import { render, staticRenderFns } from "./memberStatisticsRegionPage.vue?vue&type=template&id=6c2f70bf&scoped=true&"
import script from "./memberStatisticsRegionPage.vue?vue&type=script&lang=js&"
export * from "./memberStatisticsRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./memberStatisticsRegionPage.vue?vue&type=style&index=0&id=6c2f70bf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f70bf",
  null
  
)

export default component.exports